

































































import { Vue, Component, Prop } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { Picture } from '@/components/atoms';
import CloseIcon from '@/components/icons/Close.vue';

import segmentIo from '@/utils/segment.io';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

@Component({
  components: {
    TwismLogoIcon,
    CloseModalIcon,
    Typography,
    Picture,
    CloseIcon
  }
})
export default class BaseLayout extends Vue {
  @Prop({ default: 'dark' }) logoTheme?: 'dark' | 'light';
  @Prop({ default: true }) showNavProgress?: boolean;
  @Prop({ default: '' }) routeBackButton?: string;
  @Prop({ default: false }) hideHeader?: boolean;
  @Prop({ default: false }) showBusinessName?: boolean;

  signUpService = new SignUpService();

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get yourStoreDetailsFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'] || {};
  }

  get name() {
    return this.yourStoreDetailsFormData.businessName;
  }

  get isLogged() {
    const token = this.signUpService.getCredentials();

    return !!token || this.$store.getters['manager/isImpersonated'];
  }

  get showCloseBtn() {
    return !!this.business && !!this.isLogged;
  }

  get fullYear() {
    return new Date().getFullYear();
  }

  goBackToWebsite() {
    document.location.href = 'https://www.twism.com';
  }

  onCloseFlow() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'stopFlowModal',
        hideCancelButton: false,
        icon: '',
        mobileFullScreen: true
      }),
      {
        onConfirm: this.goBackToWebsite
      }
    );
  }

  imageSrc(name: string) {
    return require(`@/assets/img/business-onboarding/business-preview/${name}.png`);
  }

  goToSignIn() {
    segmentIo.track('BFR Sign Up | Clicked Sign in Button');
  }

  goBack() {
    this.$router.push(this.routeBackButton ? this.routeBackButton : '/home');
  }
}
